// Mock data para o site Harmonia Nupcial

export const ceremonyMoments = [
  {
    id: 1,
    moment: "Entrada do Noivo",
    description: "Momento solene que marca o início da cerimônia",
    songs: [
      {
        title: "Tu és o Centro",
        artist: "Frei Gilson",
        liturgical: true,
        note: "Música de adoração e entrega",
        youtube: "https://www.youtube.com/watch?v=FURNjcDNVd4"
      },
      {
        title: "Terra Seca",
        artist: "Fraternidade São João Paulo II",
        liturgical: true,
        note: "Canção de renovação e esperança",
        youtube: "https://www.youtube.com/watch?v=7AU4KXimRbY"
      },
      {
        title: "Hallelujah",
        artist: "Álvaro Sampietro",
        liturgical: true,
        note: "Versão católica do clássico",
        youtube: "https://www.youtube.com/watch?v=_BMUmfb9MYY"
      },
      {
        title: "Basta Querer",
        artist: "Pe. Marcelo Rossi",
        liturgical: true,
        note: "Mensagem de fé e perseverança",
        youtube: "https://www.youtube.com/watch?v=W-1WJFRyHfg"
      },
      {
        title: "Sou Teu Anjo",
        artist: "Anjos de Resgate",
        liturgical: true,
        note: "Declaração de amor e proteção",
        youtube: "https://www.youtube.com/watch?v=5ivv1o-Dccw"
      },
      {
        title: "Simples José",
        artist: "Eugênio Jorge",
        liturgical: true,
        note: "Homenagem ao papel do noivo",
        youtube: "https://www.youtube.com/watch?v=xGAawlH-RGY"
      },
      {
        title: "O Primeiro Olhar",
        artist: "Anjos de Resgate",
        liturgical: true,
        note: "Romântica e emocionante",
        youtube: "https://www.youtube.com/watch?v=4aY6wwBQ-IM"
      },
      {
        title: "Até o Fim",
        artist: "Rosa de Saron",
        liturgical: true,
        note: "Promessa de amor eterno",
        youtube: "https://youtu.be/ZzcvZYLjh18?si=fRPXsYLg-7wb1tYa"
      },
      {
        title: "Sem Você",
        artist: "Rosa de Saron",
        liturgical: true,
        note: "Declaração de amor profundo",
        youtube: "https://www.youtube.com/watch?v=ZYNCob9YjDY"
      },
      {
        title: "Romaria",
        artist: "Renato Teixeira",
        liturgical: true,
        note: "Clássico da música brasileira",
        youtube: "https://www.youtube.com/watch?v=aup_ZeTHtcI"
      }
    ]
  },
  {
    id: 2,
    moment: "Entrada dos Pais e Padrinhos",
    description: "Celebração da comunidade que acompanha os noivos",
    songs: [
      {
        title: "Amigos pela Fé",
        artist: "Anjos de Resgate",
        liturgical: true,
        note: "Celebra a amizade verdadeira",
        youtube: "https://www.youtube.com/watch?v=-_jlWkR3mUk"
      },
      {
        title: "Mais Que Amigos",
        artist: "Anjos de Resgate",
        liturgical: true,
        note: "Homenagem aos amigos especiais",
        youtube: "https://www.youtube.com/watch?v=SVEcBkKAoJ4"
      },
      {
        title: "Eternos Amigos",
        artist: "Anjos de Resgate",
        liturgical: true,
        note: "Amizade que transcende o tempo",
        youtube: "https://www.youtube.com/watch?v=Q4uL6_HIaSM"
      },
      {
        title: "Verdades do Tempo",
        artist: "Thiago Brado",
        liturgical: true,
        note: "Reflexão sobre os laços verdadeiros",
        youtube: "https://www.youtube.com/watch?v=Ilg58OE3i3M"
      },
      {
        title: "O Céu se Abre",
        artist: "Walmir Alencar",
        liturgical: true,
        note: "Canção de adoração e gratidão",
        youtube: "https://www.youtube.com/watch?v=1A-ErzCyikc"
      },
      {
        title: "Coração em Comunhão",
        artist: "Toca de Assis",
        liturgical: true,
        note: "União de corações na fé",
        youtube: "https://www.youtube.com/watch?v=b07nfcEUFnk"
      }
    ]
  },
  {
    id: 3,
    moment: "Entrada da Noiva",
    description: "O momento mais aguardado e emocionante da cerimônia",
    songs: [
      {
        title: "Ave Maria",
        artist: "Schubert",
        liturgical: true,
        note: "Clássica e emocionante",
        youtube: "https://www.youtube.com/watch?v=FCGFu3WReBk"
      },
      {
        title: "Hallelujah",
        artist: "Álvaro Sampietro",
        liturgical: true,
        note: "Versão católica do clássico",
        youtube: "https://www.youtube.com/watch?v=_BMUmfb9MYY"
      },
      {
        title: "Até o Fim",
        artist: "Rosa de Saron",
        liturgical: true,
        note: "Promessa de amor eterno",
        youtube: "https://youtu.be/ZzcvZYLjh18?si=fRPXsYLg-7wb1tYa"
      },
      {
        title: "Jesus meu Esposo",
        artist: "Fraternidade São João Paulo II",
        liturgical: true,
        note: "Entrega total ao amor",
        youtube: "https://www.youtube.com/watch?v=Jc8YfPf82vc"
      },
      {
        title: "Pai Nosso",
        artist: "Padre Marcelo Rossi",
        liturgical: true,
        note: "Oração do Senhor cantada",
        youtube: "https://www.youtube.com/watch?v=uhQcg9hpgwU"
      },
      {
        title: "Yeshua",
        artist: "Colo de Deus",
        liturgical: true,
        note: "Adoração profunda e reverente",
        youtube: "https://www.youtube.com/watch?v=Q_JWHUkdFAI"
      },
      {
        title: "Escolhi te Esperar",
        artist: "Lorenza Pozza",
        liturgical: true,
        note: "Declaração de amor e espera",
        youtube: "https://www.youtube.com/watch?v=UNkofhd5In8"
      },
      {
        title: "Pra Sonhar",
        artist: "Lorenza Pozza",
        liturgical: true,
        note: "Romântica e delicada",
        youtube: "https://www.youtube.com/watch?v=alp-rHKrY5o"
      },
      {
        title: "Eles se Amam",
        artist: "Vocal Livre",
        liturgical: true,
        note: "Celebração do amor do casal",
        youtube: "https://www.youtube.com/watch?v=SxJGXR9cHgs"
      },
      {
        title: "O Cântico de Maria",
        artist: "Ministério Adoração e Vida",
        liturgical: true,
        note: "Magnificat - canto de Nossa Senhora",
        youtube: "https://www.youtube.com/watch?v=_2ivJVaaZGU"
      }
    ]
  },
  {
    id: 4,
    moment: "Salmo",
    description: "Resposta meditativa à Palavra de Deus",
    songs: [
      {
        title: "Salmo 127",
        artist: "Tradicional litúrgica",
        liturgical: true,
        note: "Felizes os que temem o Senhor e trilham seus caminhos",
        youtube: "https://www.youtube.com/watch?v=0xw3JampMxc"
      },
      {
        title: "Salmo 139 - Sonda-me",
        artist: "Padre Marcelo Rossi",
        liturgical: true,
        note: "Oração de entrega e purificação",
        youtube: "https://www.youtube.com/watch?v=oKDYCzIJ154"
      }
    ]
  },
  {
    id: 5,
    moment: "Aclamação ao Evangelho",
    description: "Momento de louvor antes da proclamação da Palavra",
    songs: [
      {
        title: "Aleluia a Minh'alma Abrirei",
        artist: "Tradicional litúrgica",
        liturgical: true,
        note: "Aclamação tradicional católica",
        youtube: "https://www.youtube.com/watch?v=iOJazAXasB4"
      },
      {
        title: "Eterna Vida",
        artist: "Comunidade Católica Shalom",
        liturgical: true,
        note: "Aclamação católica moderna",
        youtube: "https://www.youtube.com/watch?v=KZtnyLZAcX4"
      }
    ]
  },
  {
    id: 6,
    moment: "Entrada das Alianças",
    description: "Momento simbólico da união eterna do casal",
    songs: [
      {
        title: "Aliança Verdadeira",
        artist: "Nossa Canção",
        liturgical: true,
        note: "Celebra o compromisso eterno",
        youtube: "https://www.youtube.com/watch?v=JvJz_niUpUg"
      },
      {
        title: "Essa Aliança",
        artist: "Entretons",
        liturgical: true,
        note: "Símbolo do amor que não se rompe",
        youtube: "https://www.youtube.com/watch?v=ZiL-FWjgDO0"
      },
      {
        title: "O Primeiro Olhar",
        artist: "Anjos de Resgate",
        liturgical: true,
        note: "Romântica e emocionante",
        youtube: "https://www.youtube.com/watch?v=4aY6wwBQ-IM"
      },
      {
        title: "Sou Teu Anjo",
        artist: "Anjos de Resgate",
        liturgical: true,
        note: "Declaração de amor e proteção",
        youtube: "https://www.youtube.com/watch?v=5ivv1o-Dccw"
      },
      {
        title: "Sinal do Meu Amor",
        artist: "Davidson Silva",
        liturgical: true,
        note: "Promessa de fidelidade",
        youtube: "https://www.youtube.com/watch?v=Jgv0nEDu1U0"
      },
      {
        title: "Pra Sempre",
        artist: "Nicodemos Costa",
        liturgical: true,
        note: "Amor eterno e incondicional",
        youtube: "https://www.youtube.com/watch?v=OL3tmFHOmfQ&t=14s"
      }
    ]
  },
  {
    id: 7,
    moment: "Comunhão",
    description: "Momento mais sagrado da celebração eucarística",
    songs: [
      {
        title: "Como és Lindo",
        artist: "Vida Reluz",
        liturgical: true,
        note: "Adoração ao Santíssimo",
        youtube: "https://www.youtube.com/watch?v=TTJLNXfJlIQ"
      },
      {
        title: "Corpo Santo",
        artist: "Fátima Souza",
        liturgical: true,
        note: "Reverência ao corpo de Cristo",
        youtube: "https://www.youtube.com/watch?v=bLjpWvdG1FY"
      },
      {
        title: "Doce Comunhão",
        artist: "Romanos",
        liturgical: true,
        note: "Encontro íntimo com Jesus",
        youtube: "https://www.youtube.com/watch?v=SSr8tWo3VwI"
      },
      {
        title: "Majestosa Eucaristia",
        artist: "Anjos de Resgate",
        liturgical: true,
        note: "Adoração eucarística",
        youtube: "https://www.youtube.com/watch?v=LeWYTlBD9tI"
      },
      {
        title: "Belíssimo Esposo",
        artist: "Comunidade Católica Shalom",
        liturgical: true,
        note: "Canção de amor a Cristo",
        youtube: "https://www.youtube.com/watch?v=ycMiym91-Vg"
      },
      {
        title: "A Tua Ternura",
        artist: "Comunidade Católica Shalom",
        liturgical: true,
        note: "Meditação sobre o amor de Deus",
        youtube: "https://www.youtube.com/watch?v=hQO-91W6vvc"
      }
    ]
  },
  {
    id: 8,
    moment: "Assinatura e Fotos",
    description: "Momento de formalização do matrimônio",
    songs: [
      {
        title: "Você e Eu",
        artist: "Eliana Ribeiro",
        liturgical: true,
        youtubeUrl: "https://www.youtube.com/watch?v=LZCbBiG_rKA",
        note: "Letra sobre a união do casal em Deus, perfeita para esse momento especial"
      },
      {
        title: "Do Alto da Pedra",
        artist: "Rosa de Saron",
        liturgical: true,
        youtubeUrl: "https://www.youtube.com/watch?v=P0J9gdqDEXI",
        note: "Canção reflexiva sobre construir a vida sobre a rocha, ideal para registrar o compromisso"
      },
      {
        title: "Apenas uma Canção de amor",
        artist: "Rosa de Saron",
        liturgical: true,
        youtubeUrl: "https://www.youtube.com/watch?v=lDV_EIggeGM",
        note: "Melodia suave e romântica, combina bem com fotos do casal"
      },
      {
        title: "Teus planos",
        artist: "Juninho Cassimiro",
        liturgical: true,
        youtubeUrl: "https://www.youtube.com/watch?v=1PcgVTOhOEM",
        note: "Letra que fala sobre confiar nos planos de Deus para o casal"
      },
      {
        title: "Deixa Deus Sonhar em ti",
        artist: "Frei Gilson",
        liturgical: true,
        youtubeUrl: "https://www.youtube.com/watch?v=f_qzhaIdis0",
        note: "Mensagem de entrega e confiança, muito emocionante"
      },
      {
        title: "Tu és o centro",
        artist: "Frei Gilson",
        liturgical: true,
        youtubeUrl: "https://www.youtube.com/watch?v=5Ucj-_2qpdA",
        note: "Adoração que coloca Deus no centro da vida conjugal"
      },
      {
        title: "Guardiões",
        artist: "Adriana Arydes",
        liturgical: true,
        youtubeUrl: "https://www.youtube.com/watch?v=i0ZR2bvlYyc",
        note: "Canção sobre guardar o amor com dedicação e fidelidade"
      },
      {
        title: "Seu Amor É Demais",
        artist: "Banda Dom",
        liturgical: true,
        youtubeUrl: "https://www.youtube.com/watch?v=4ftlVVR4lMc",
        note: "Louvor alegre e emotivo, celebra o amor de Deus no matrimônio"
      },
      {
        title: "Minha Essência",
        artist: "Thiago Brado",
        liturgical: true,
        youtubeUrl: "https://www.youtube.com/watch?v=bklas0_vUg4",
        note: "Letra profunda sobre identidade e amor, muito tocante"
      },
      {
        title: "Oração pela Familia",
        artist: "Pe. Zezinho",
        liturgical: true,
        youtubeUrl: "https://www.youtube.com/watch?v=-IRFxJI0Rm8",
        note: "Clássico que abençoa a nova família, ideal para encerrar o momento"
      }
    ]
  },
  {
    id: 9,
    moment: "Saída dos Noivos",
    description: "Celebração final e envio dos noivos",
    songs: [
      {
        title: "Oração pela Familia",
        artist: "Pe. Zezinho",
        liturgical: true,
        youtubeUrl: "https://www.youtube.com/watch?v=-IRFxJI0Rm8",
        note: "Clássico que abençoa a nova família, encerramento perfeito"
      },
      {
        title: "Eu Seguirei",
        artist: "Frei Gilson",
        liturgical: true,
        youtubeUrl: "https://www.youtube.com/watch?v=qMRYBG6d7XY",
        note: "Animada e cheia de esperança, celebra o início da nova jornada"
      },
      {
        title: "O Primeiro Olhar",
        artist: "Anjos de Resgate",
        liturgical: true,
        youtubeUrl: "https://www.youtube.com/watch?v=4aY6wwBQ-IM",
        note: "Romântica e emocionante, fala sobre o amor à primeira vista"
      },
      {
        title: "Chuva de Graça",
        artist: "Eliana Ribeiro",
        liturgical: true,
        youtubeUrl: "https://www.youtube.com/watch?v=6LtGCqX8eNE",
        note: "Louvor alegre que celebra as bênçãos de Deus sobre o casal"
      }
    ]
  }
];

export const portfolioItems = [
  {
    id: 1,
    title: "Salmo 127",
    artist: "Versão Harmonia Nupcial",
    moment: "Salmo",
    description: "Gravação ao vivo durante cerimônia real. O Salmo 127 fala sobre as bênçãos do lar edificado em Deus.",
    type: "cover",
    instagramUrl: "https://www.instagram.com/reel/DS5Uo9TER5t/"
  },
  {
    id: 2,
    title: "Essa Aliança",
    artist: "Versão Harmonia Nupcial",
    moment: "Entrada das Alianças",
    description: "Gravação ao vivo durante cerimônia real. Música emocionante que celebra o símbolo do amor eterno.",
    type: "cover",
    instagramUrl: "https://www.instagram.com/reel/DSlNQEajRtd/"
  },
  {
    id: 3,
    title: "Como és Lindo",
    artist: "Versão Harmonia Nupcial",
    moment: "Comunhão",
    description: "Gravação ao vivo durante cerimônia real. Louvor de adoração perfeito para o momento mais sagrado da celebração.",
    type: "cover",
    instagramUrl: "https://www.instagram.com/reel/DQRtrBwkaZe/"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Maria & Acyr",
    date: "Dezembro 2023",
    text: "Foi tudo perfeito! Essa é um equipe maravilhosa. Super atenciosos, talentosos e cuidadosos. O que mais tocou foi a música de Entrega das alianças",
    rating: 5
  },
  {
    id: 2,
    name: "Samara & Luís",
    date: "Março 2025",
    text: "A entrada foi simplesmente perfeita! Para nós, não houve nada a melhorar foi tudo exatamente como sonhamos. O Douglas e a Ana foram maravilhosos e tornaram nosso momento ainda mais especial.",
    rating: 5
  },
  {
    id: 3,
    name: "Hugo & Brenda",
    date: "Outubro 2025",
    text: "Só temos elogios ao Harmonia Nupcial! Tudo foi perfeito, desde a comunicação sempre clara e tranquila até a música, que deixou nosso dia ainda mais especial. Parabéns pelo trabalho impecável, vocês vão longe, Ainda bem que a Samara indicou vocês!",
    rating: 5
  }
];

export const companyInfo = {
  name: "Harmonia Nupcial",
  tagline: "Música Sacra que Celebra o Amor Eterno",
  description: "Especializados em cerimônias católicas, levamos música de qualidade e reverência para o dia mais especial da sua vida. Com repertório criteriosamente selecionado e respeito à liturgia, transformamos sua cerimônia em um momento inesquecível de fé e amor.",
  mission: "Nossa missão é proporcionar aos noivos uma experiência musical sublime, unindo tradição católica, qualidade técnica e sensibilidade artística, tornando cada cerimônia única e memorável.",
  whatsapp: "5561995878906",
  email: "nupcialharmonia@gmail.com",
  instagram: "@harmonianupcialbsb",
  location: "Brasília - DF"
};